import styled from "styled-components";

export const SwitcherWrapper = styled.div`
  grid-column: 1 / -1;
  display: grid;
  gap: 20px;
  min-width: 0;
`;
